import { MatchesOverviewTable } from '@/components';


export default {
  name: 'MatchesOverview',
  components: {
    MatchesOverviewTable,
  },
  props: {},
  data: () => ({
  }),
  computed: {},
  methods: {
  },
  created() {
  },
};
